import React, { DependencyList, ReactNode, useRef } from "react";
import NewLookIntroTabs from "common/Tabs/NewLookIntroTabs";
import { usePageIntro } from "common/NewLook";

interface NewLookSignalsIntroProps {
  activeKey: string;
  tabsItems: { key: string; label: string }[];
  onTabChange: (key: string) => void;
  actions?: ReactNode;
  deps: DependencyList;
}

/**
 * Moves the open / closed tabs and the page actions into the new-look page
 * intro. Renders nothing itself.
 */
const NewLookSignalsIntro = ({
  activeKey,
  tabsItems,
  onTabChange,
  actions,
  deps,
}: NewLookSignalsIntroProps) => {
  const onTabChangeRef = useRef(onTabChange);
  onTabChangeRef.current = onTabChange;

  usePageIntro(
    {
      actions,
      footer: (
        <NewLookIntroTabs
          activeKey={activeKey}
          onChange={(key: string) => onTabChangeRef.current(key)}
          items={tabsItems}
        />
      ),
    },
    [activeKey, tabsItems, ...deps]
  );

  return null;
};

export default NewLookSignalsIntro;
